export const isExportTransactionType = (transactionType) =>
  typeof transactionType === "string" &&
  transactionType.length === 20 &&
  transactionType.charAt(6) === "1";
